import { ListItem, Theme, Typography } from '@material-ui/core';
import { fade } from '@material-ui/core/styles';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import React, { FunctionComponent, useState } from 'react';
import {
  amber_faded_black,
  amber_medium_grey,
  amber_very_faded_black,
  nav_account_group_bg_color,
  nav_selected_bin_bg_color,
  nav_site_group_bg_color,
} from '../../style';

// Re-export so ContainerListItem can import from one place
export const nav_account_group_bg = nav_account_group_bg_color;
export const nav_site_group_bg = nav_site_group_bg_color;
export const nav_selected_bin_bg = nav_selected_bin_bg_color;

const useStyles = makeStyles((theme: Theme) => ({
  groupRoot: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderBottom: `solid 1px ${amber_very_faded_black}`,
    backgroundColor: nav_site_group_bg,
    '&:hover': {
      backgroundColor: fade(nav_site_group_bg, 0.7),
    },
    cursor: 'pointer',
  },
  accountGroupRoot: {
    backgroundColor: nav_account_group_bg,
    '&:hover': {
      backgroundColor: fade(nav_account_group_bg, 0.7),
    },
  },
  label: {
    color: amber_faded_black,
    fontWeight: 600,
    fontSize: 13,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: 1,
  },
  icon: {
    color: amber_medium_grey,
    fontSize: 18,
    flexShrink: 0,
  },
}));

export const ContainerNavGroupItem: FunctionComponent<{
  label: string;
  depth: number; // 0 = account level, 1 = site level
  children: React.ReactNode;
  defaultExpanded?: boolean;
}> = ({ label, depth, children, defaultExpanded = true }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(defaultExpanded);

  return (
    <>
      <ListItem
        button={false}
        component="div"
        className={`${classes.groupRoot} ${depth === 0 ? classes.accountGroupRoot : ''}`}
        onClick={() => setOpen((prev) => !prev)}
        style={{ paddingLeft: depth === 1 ? 32 : 16 }}
      >
        <Typography className={classes.label}>{label}</Typography>
        {open ? <ExpandLess className={classes.icon} /> : <ExpandMore className={classes.icon} />}
      </ListItem>
      <div style={{ display: open ? 'block' : 'none' }}>{children}</div>
    </>
  );
};
